import {
  FETCH_BRANDS,
  FETCH_BRANDS_SUCCESS,
  FETCH_BRANDS_FAILURE,
  FETCH_VERSIONS,
  FETCH_VERSIONS_SUCCESS,
  FETCH_VERSIONS_FAILURE,
  FETCH_CONTENT_TYPES,
  FETCH_CONTENT_TYPES_SUCCESS,
  FETCH_CONTENT_TYPES_FAILURE,
  FETCH_BRAND_STATUS,
  FETCH_BRAND_STATUS_SUCCESS,
  FETCH_BRAND_STATUS_FAILURE,
  FETCH_BRAND_PROGRESS,
  FETCH_BRAND_PROGRESS_SUCCESS,
  FETCH_BRAND_PROGRESS_FAILURE,
  REINDEX_BRAND,
  REINDEX_BRAND_SUCCESS,
  REINDEX_BRAND_FAILURE,
  STOP_REINDEX,
  STOP_REINDEX_SUCCESS,
  STOP_REINDEX_FAILURE,
  REINDEX_BY_ID,
  REINDEX_BY_ID_SUCCESS,
  REINDEX_BY_ID_FAILURE,
  SET_VERSIONS,
  SET_VERSIONS_SUCCESS,
  SET_VERSIONS_FAILURE,
  SET_CONTENT_TYPES,
} from './types'

export const fetchBrands = (accessToken) => ({
  type: FETCH_BRANDS,
  payload: { accessToken },
})

export const fetchBrandsSuccess = (brands) => ({
  type: FETCH_BRANDS_SUCCESS,
  payload: brands,
})

export const fetchBrandsFailure = (error) => ({
  type: FETCH_BRANDS_FAILURE,
  payload: error,
})

export const fetchVersions = (accessToken) => ({
  type: FETCH_VERSIONS,
  payload: { accessToken },
})

export const fetchVersionsSuccess = (versions) => ({
  type: FETCH_VERSIONS_SUCCESS,
  payload: versions,
})

export const fetchVersionsFailure = (error) => ({
  type: FETCH_VERSIONS_FAILURE,
  payload: error,
})

export const fetchContentTypes = (accessToken) => ({
  type: FETCH_CONTENT_TYPES,
  payload: { accessToken },
})

export const fetchContentTypesSuccess = (contentTypes) => ({
  type: FETCH_CONTENT_TYPES_SUCCESS,
  payload: contentTypes,
})

export const fetchContentTypesFailure = (error) => ({
  type: FETCH_CONTENT_TYPES_FAILURE,
  payload: error,
})

export const fetchBrandStatus = (brandName, indexName, contentTypes, accessToken) => ({
  type: FETCH_BRAND_STATUS,
  payload: { brandName, indexName, contentTypes, accessToken },
})

export const fetchBrandStatusSuccess = (brandName, indexName, data) => ({
  type: FETCH_BRAND_STATUS_SUCCESS,
  payload: { brandName, indexName, data },
})

export const fetchBrandStatusFailure = (brandName, indexName, error) => ({
  type: FETCH_BRAND_STATUS_FAILURE,
  payload: { brandName, indexName, error },
})

export const fetchBrandProgress = (brandName, accessToken) => ({
  type: FETCH_BRAND_PROGRESS,
  payload: { brandName, accessToken },
})

export const fetchBrandProgressSuccess = (brandName, data) => ({
  type: FETCH_BRAND_PROGRESS_SUCCESS,
  payload: { brandName, data },
})

export const fetchBrandProgressFailure = (brandName, error) => ({
  type: FETCH_BRAND_PROGRESS_FAILURE,
  payload: { brandName, error },
})

export const reindexBrand = (brandName, contentTypes, accessToken) => ({
  type: REINDEX_BRAND,
  payload: { brandName, contentTypes, accessToken },
})

export const reindexBrandSuccess = (brandName) => ({
  type: REINDEX_BRAND_SUCCESS,
  payload: brandName,
})

export const reindexBrandFailure = (brandName, error) => ({
  type: REINDEX_BRAND_FAILURE,
  payload: { brandName, error },
})

export const stopReindex = (brandName, accessToken) => ({
  type: STOP_REINDEX,
  payload: { brandName, accessToken },
})

export const stopReindexSuccess = (brandName) => ({
  type: STOP_REINDEX_SUCCESS,
  payload: brandName,
})

export const stopReindexFailure = (brandName, error) => ({
  type: STOP_REINDEX_FAILURE,
  payload: { brandName, error },
})

export const setVersions = (versions, accessToken) => ({
  type: SET_VERSIONS,
  payload: { versions, accessToken },
})

export const setVersionsSuccess = () => ({
  type: SET_VERSIONS_SUCCESS,
})

export const setVersionsFailure = (error) => ({
  type: SET_VERSIONS_FAILURE,
  payload: error,
})

export const reindexById = (documentIds, accessToken) => ({
  type: REINDEX_BY_ID,
  payload: { documentIds, accessToken },
})

export const reindexByIdSuccess = () => ({
  type: REINDEX_BY_ID_SUCCESS,
})

export const reindexByIdFailure = (error) => ({
  type: REINDEX_BY_ID_FAILURE,
  payload: error,
})

export const setContentTypes = (contentTypes, accessToken) => ({
  type: SET_CONTENT_TYPES,
  payload: { contentTypes, accessToken },
})
